import { Calendar, CheckboxVisibility, DateRangeType, DayOfWeek, ShimmeredDetailsList } from '@fluentui/react';
import moment from 'moment';
import React, { ReactElement, useEffect, useMemo, useState } from 'react';
import { searchIndex } from '../../api';

interface Props {
  providerId: string;
}

export function ProviderScheduleList({ providerId }: Props): ReactElement {
  const [schedules, setSchedules] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selectedDate, setSelectedDate] = useState<Date>(new Date());

  useEffect(() => {
    setLoading(true);
    const filter: any[] = [
      {
        range: {
          scheduled_start_time: {
            gte: `${moment(selectedDate).format('YYYY-MM-DDT00:00:00.000-08:00')}`,
            lt: `${moment(selectedDate).add(7, 'd').format('YYYY-MM-DDT00:00:00.000-08:00')}`,
          },
        },
      },
    ];

    searchIndex('logstash-provider_schedule', `active:true AND provider_id:${providerId}`, filter)
      .then((result) => {
        result.sort(function compare(a: any, b: any) {
          return new Date(a.scheduled_start_time).getTime() - new Date(b.scheduled_start_time).getTime();
        });
        setSchedules(result);
      })
      .finally(() => setLoading(false));
  }, [providerId, selectedDate]);

  const columns = useMemo(() => {
    return [
      {
        key: 'location_name',
        name: 'Location Name',
        fieldName: 'location_name',
        minWidth: 80,
        maxWidth: 120,
      },
      {
        key: 'position_type',
        name: 'Position Type',
        fieldName: 'position_type',
        minWidth: 120,
        maxWidth: 200,
      },
      {
        key: 'site_name',
        name: 'Job Site',
        fieldName: 'site_name',
        minWidth: 120,
        maxWidth: 240,
      },
      {
        key: 'scheduled_start_time',
        name: 'Start time',
        fieldName: 'scheduled_start_time',
        minWidth: 160,
        maxWidth: 160,
      },
      {
        key: 'scheduled_end_time',
        name: 'End time',
        fieldName: 'scheduled_end_time',
        minWidth: 160,
        maxWidth: 160,
      },
    ];
  }, []);

  return (
    <div>
      <Calendar
        onSelectDate={(d, range) => range && setSelectedDate(range[0])}
        isMonthPickerVisible={true}
        highlightSelectedMonth={true}
        showGoToToday={false}
        dateRangeType={DateRangeType.Week}
        value={selectedDate!}
        firstDayOfWeek={DayOfWeek.Sunday}
        isDayPickerVisible={true}
      />
      <ShimmeredDetailsList enableShimmer={loading} checkboxVisibility={CheckboxVisibility.hidden} items={schedules} setKey="set" columns={columns} />
    </div>
  );
}
